import { Box, styled, Typography } from '@mui/material';

export const FieldWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'noPaddingTop' && prop !== 'noPadding',
})(({ noPaddingTop, noPadding }) => {
  const getPadding = () => {
    if (noPadding) {
      return 0;
    }
    if (noPaddingTop) {
      return '0 5px 0 8px';
    }
    return '9px 5px 0 8px';
  };
  return {
    padding: getPadding(),
  };
});

export const LabelContainer = styled(Typography)(({ theme, disabled }) => ({
  color: disabled
    ? theme.palette.colors.secondaryDisabledText
    : theme.palette.colors.mainFocused,
  fontSize: '12px',
  fontWeight: 'bold',
  lineHeight: 'normal',
  marginBottom: '5px',
  display: 'block',

  [theme.breakpoints.up('xxl')]: {
    display: 'flex',
  },
}));

export const Label = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isRequired',
})(({ theme, disabled, isRequired }) => ({
  '&::after': {
    content: "'*'",
    color: disabled
      ? theme.palette.colors.secondaryDisabledText
      : theme.palette.colors.down,
    marginLeft: '6px',
    display: isRequired ? 'inline-block' : 'none',

    [theme.breakpoints.up('xxl')]: {
      display: 'none',
    },
  },

  [theme.breakpoints.up('xxl')]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
